import {
  applyIncubateActionUpdate,
  getDefaultIncubateAction,
  IncubateAction,
  IncubateActionUpdate,
} from 'client/app/apps/disco-prototype/state/actions/incubateAction';
import {
  applyMakeMixtureActionUpdate,
  getDefaultMakeMixture,
  MakeMixtureAction,
  MakeMixtureActionUpdate,
} from 'client/app/apps/disco-prototype/state/actions/makeMixtureAction';
import { LiquidSet } from 'client/app/apps/disco-prototype/state/liquidSet';
import { assert } from 'common/lib/assertions';

export type ActionId = string;

export type Action = MakeMixtureAction | IncubateAction;

export type ActionType = Action['type'];

export const getDefaultAction = (type: ActionType): Action => {
  switch (type) {
    case 'makeMixture':
      return getDefaultMakeMixture();
    case 'incubate':
      return getDefaultIncubateAction();
    default: {
      const _: never = type;
      console.error(`unexpected action type ${_}`);
      return getDefaultMakeMixture();
    }
  }
};

export type ActionUpdate = MakeMixtureActionUpdate | IncubateActionUpdate;

export const applyActionUpdate = (
  action: Action,
  liquidSets: LiquidSet[],
  target?: LiquidSet,
  update?: ActionUpdate,
) => {
  if (!update) return;
  switch (action.type) {
    case 'makeMixture': {
      assert(update.type === 'makeMixture', 'expected makeMixture update');
      applyMakeMixtureActionUpdate(action, liquidSets, target, update);
      break;
    }
    case 'incubate': {
      assert(update.type === 'incubate', 'expected incubate update');
      applyIncubateActionUpdate(action, update);
      break;
    }
    default: {
      const _: never = action;
      console.error(`unexpected action ${_}`);
    }
  }
};
